import React, { useState, useContext } from "react";
import { useHistory, useNavigate } from "react-router-dom";
import "../Login/Login.css";
// import API from "../../utils/API";
import axios from "axios";
import AlertContext from "../../utils/alertContext";
import UserNav from "../../Components/UserNav.jsx/UserNav";

const Login = (props, { login }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const alert = useContext(AlertContext);

  const navigate = useNavigate()

  const handleFormSubmit = (e) => {
    e.preventDefault();
    axios
      .post("/login", { email, password })
      .then((response) => {
        window.localStorage.setItem("idToken", `Bearer ${response.data.idToken}`)
        window.localStorage.setItem("e", response.data.message)
        navigate('/admin/orders')
      })
      .catch((err) => {
        console.log(err);
        alert.setAlert({
          message: "Incorrect Username or Password please try again!",
          type: "danger",
        });
      });
  };

  return (
    <>
      <UserNav />
      <div className="container login-card">
        <div className="row">
          <div className="col s12 m6">
            <div className="card adminMenu">
              <div className="card-content white-text">
              <h3 className="center-align formHead">Employee Login</h3>
                <div className="row">
                  <form className="col s12" onSubmit={handleFormSubmit}>
                    <div className="row">
                      <div className="input-field col s12">
                        <input
                          id="email"
                          type="email"
                          className="validate"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />
                        <label htmlFor="email">Email</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="input-field col s12">
                        <input
                          id="password"
                          type="password"
                          className="validate"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                        />
                        <label htmlFor="password">Password</label>
                      </div>
                      <button
                        className="btn waves-effect waves-light submit-button"
                        type="submit"
                        name="action"
                      >
                        Sign In
                      </button>
                    </div>
                    <p className="center-align">{alert.message}</p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
